import { memo } from "react";
import { useDrop } from "react-dnd";

import { FormComponents as Components } from "./FormComponents.js";

import AddTextToFormDialog from "./components/AddTextToFormDialog.js";
import AddTextAreaToFormDialog from "./components/AddTextAreaToFormDialog.js";
import AddContentToFormDialog from "./components/AddContentToFormDialog.js";
import AddRadioButtonToFormDialog from "./components/AddRadioButtonToFormDialog.js";
import AddDropDownToFormDialog from "./components/AddDropDownToFormDialog.js";
import AddCheckboxToFormDialog from "./components/AddCheckboxToFormDialog";

export const FormDropBox = memo(function FormDropBox({
  lastDroppedComponent,
  closeAddDialog,
  onDrop,
  passComOptions,
}) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [
      Components.TEXT_FIELD,
      Components.TEXT_AREA_FIELD,
      Components.CONTENT_FIELD,
      Components.RADIO_BUTTON,
      Components.DROP_DOWN_FIELD,
      Components.CHECKBOX_FIELD,
    ],
    drop(_item, monitor) {
      onDrop(monitor.getItemType());
      return undefined;
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      draggingColor: monitor.getItemType(),
    }),
  });

  return (
    <div
      ref={drop}
      role="FormDropBox"
      style={{
        border: "1px dashed grey",
        borderRadius: "8px",
        height: "50px",
        textAlign: "center",
      }}
    >
      {!canDrop && lastDroppedComponent === "Text" && (
        <AddTextToFormDialog closeDialog={closeAddDialog} handleDone={passComOptions} />
      )}
      {!canDrop && lastDroppedComponent === "Text Area" && (
        <AddTextAreaToFormDialog
          closeDialog={closeAddDialog}
          handleDone={passComOptions}
        />
      )}
      {!canDrop && lastDroppedComponent === "Content" && (
        <AddContentToFormDialog
          closeDialog={closeAddDialog}
          handleDone={passComOptions}
        />
      )}
      {!canDrop && lastDroppedComponent === "Radio Button" && (
        <AddRadioButtonToFormDialog
          closeDialog={closeAddDialog}
          handleDone={passComOptions}
        />
      )}
      {!canDrop && lastDroppedComponent === "Drop Down" && (
        <AddDropDownToFormDialog
          closeDialog={closeAddDialog}
          handleDone={passComOptions}
        />
      )}
      {!canDrop && lastDroppedComponent === "Checkbox" && (
        <AddCheckboxToFormDialog
          closeDialog={closeAddDialog}
          handleDone={passComOptions}
        />
      )}
    </div>
  );
});
